"use client";
import { getEmbedUrl } from '@/lib/getEmbedUrl';
import { isYouTube } from '@/lib/isYouTube'
import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect, useState } from 'react'

const LiveEvent = () => {
  const [data, setData] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [activeLive, setActiveLive] = useState<any | null>(null);
  const now = new Date();

  useEffect(() => {
    const fetchLiveEvent = async () => {
      const res = await fetch("/api/auth/live");
      const json = await res.json();
      setData(json.data);
      const now = new Date();

      const liveItem = json.data.find((item: any) => {
        const tillTime = new Date(item.timeTillLive);
        return item.isLive && now <= tillTime;
      });

      if (liveItem) {
        setActiveLive(liveItem);
        setShowModal(true);
      } else {
        setShowModal(false);
        setActiveLive(null);
      }
    };
    fetchLiveEvent();
  }, []);

 return (
    <div>
      <div className="relative z-5000 max-w-3xl w-full px-4">
        {
          data?.map((item, index) => {
            const tillTime = new Date(item.timeTillLive);
            if (!item.isLive || now > tillTime) {
              return null;
            }
            const ytEmbed = getEmbedUrl(item.video);
            return (
              <div key={index}>
                {showModal && activeLive && (
                  <div className="fixed inset-0 z-50 bg-opacity-70 flex bg-black/70 justify-center items-center p-4"
                  onClick={() => setShowModal(false)}
                  >
                    <button
                      onClick={() => setShowModal(false)}
                      className="absolute top-4 right-4 z-9999 
                                 p-3 bg-white rounded-full shadow hover:bg-gray-200 cursor-pointer"
                      aria-label="Close video Modal">
                      <Icon icon="ic:round-close" className="cursor-pointer text-xl" />
                    </button>

                    <div className="relative z-5000 max-w-3xl w-full px-4">
                      {
                        isYouTube(activeLive.video) && ytEmbed ?
                          <iframe
                            src={ytEmbed}
                            className="w-full h-96 md:h-125 rounded"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                          :
                          <video
                            src={activeLive.video}
                            controls
                            className="w-full h-96 md:h-125 rounded"
                          ></video>}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default LiveEvent;



